export const homeCardGoalReportFields = [
  {
    id: '1',
    title: 'Total Vendido',
    valueFormatted: true,
    field: 'valor',
  },
  {
    id: '2',
    title: 'Objetivo mensal',
    valueFormatted: true,
    field: 'valorCota',
  },
  {
    id: '3',
    title: 'Objetivo do dia',
    valueFormatted: true,
    field: 'valorDia',
  },
  {
    id: '4',
    title: 'Qtd de vendas',
    valueFormatted: false,
    field: 'quantidadeVendas',
  },
  {
    id: '5',
    title: 'Dias restantes',
    valueFormatted: false,
    field: 'diasFaltantes',
  },
  {
    id: '6',
    title: 'Carteira de clientes',
    valueFormatted: false,
    field: 'clientesTotal',
  },
]
